import { G_EasingFunctionDefaults } from "../../../utils/globals/option-function-defaults";
import checkReferenceHooks from "./references/check-reference-hooks";
import setParentStyle from "./set-parent-style";

/**
 * Process each property in step
 * @param {Array<StepProps>} input Step
 * @param {MainClassProps} main
 * @param {TriggerProps} trigger
 */
const processStepParents = (input, main, trigger) => {
  /** Loop each step */
  for (const step of input) {
    const original = step.get("original");

    /** Get properties in the step */
    const parents = original.split("▥");

    /** All parent properties */
    step.set("properties", new Map());

    /** The flat properties map with all pure values in a flat array */
    step.set("flat", []);
    step.set("properties-count", 0);
    step.set("pure", new Map());
    step.set("should-process", false);

    /** Default step options */
    step.set("start-time", null);
    step.set("current-iteration", 0);
    step.set("percents-unlimited", -1);
    step.set("percents", 0);
    step.set("progress", 0);
    step.set("o_delay", 0);
    step.set("o_pause", 0);
    step.set("o_iterations", 0);
    step.set("o_duration", -1);
    step.set("o_easing", G_EasingFunctionDefaults.get("ease-in-out"));
    step.set("enter-percents", 0);
    step.set("leave-percents", 1);
    step.set("enter-overall", 1);
    step.set("leave-overall", 0);
    step.set("enter-progress", 0);
    step.set("leave-progress", 0);
    step.set("last-progress-array", []);
    step.set("last-progress", 0);
    step.set("last-enter", true);
    step.set("has-spring", false);
    step.set("status-enter-started", false);
    step.set("status-enter-finished", false);
    step.set("status-leave-started", false);
    step.set("status-leave-finished", false);
    step.set("finished", false);
    step.set("started", false);
    step.set("is-active", false);

    checkReferenceHooks(step, step.get("options"), true);

    const refs = /** @type {Array<Map<String, any>>} */ (
      main.storage.get("parent-refs")
    );

    refs.push(step);

    /**
     * Loop trough parents array
     * @example ["opacity(1)", "tx(2rem<2s>)"]
     */
    for (const parent of parents) {
      setParentStyle(parent, trigger, step, main);
    }

    const properties = /** @type {Map<String, any>} */ (step.get("properties"));

    for (const property of properties.values()) {
      const count = step.get("properties-count");

      step.set("properties-count", count + property.size);
    }
  }
};

export default processStepParents;
